// ============= User-facing messages =============

export const VISUAL_PROMPT_MESSAGES = {
  sectionTitle: 'Visual Prompts',
  sectionDescription:
    'Guided prompts for law firm business systems—comms, rollouts, training, and internal tools. Answer a few questions and we build the brief for you.',
  loadError: 'Unable to load visual prompts',
  loadErrorRetry: 'Retry',
  emptyList: 'No visual prompts available',
  runPrompt: 'Run prompt',
  runningPrompt: 'Starting chat…',
  runSuccess: 'Chat started with your prompt',
  runError: 'Unable to start chat with this prompt',
  back: 'Back',
  continue: 'Continue',
  previewTitle: 'Prompt preview',
  previewToggleShow: 'Show preview',
  previewToggleHide: 'Hide preview',
  searchPlaceholder: 'Search prompts…',
  allCategories: 'All',
  stepsLabel: 'steps',
  requiredField: 'Please complete this step before continuing.',
  filterLabel: 'Category',
  featuredLabel: 'Quick access',
  addToQuickAccess: 'Add to Quick access',
  removeFromQuickAccess: 'Remove from Quick access',
  oneTimeUseNote:
    'Each run starts fresh. Save your choices on the review step to reuse audience, tone, and rules next time (not your pasted text).',
  saveChoices: 'Save my choices for next time',
  saveChoicesSuccess: 'Choices saved for this prompt',
  reviewWorkspace: 'Workspace',
  reviewChannel: 'Channel',
  reviewMatter: 'Matter-related',
  previewThinWarning:
    'This brief looks short. Add pasted text in the previous step, or attach documents in Ask after you run.',
  attachAfterRunHint:
    'You can attach documents in the Ask chat after starting.',
} as const;
